import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=983b89aa&scoped=true"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b89aa",
  null
  
)

export default component.exports